import React from "react";
import styled from "styled-components/macro";

import {
  Button,
  Grid,
  Hidden,
  List,
  ListItemText as MuiListItemText,
  ListItem as MuiListItem,
} from "@material-ui/core";
import TranslateIcon from "@material-ui/icons/Translate";
import { useTranslation } from "react-i18next";
import { changeAndPersistLanguage } from "../services/localizationService";

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(1) / 4}px
    ${(props) => props.theme.spacing(4)}px;
  background: ${(props) => props.theme.footer.background};
  position: relative;
`;

const ListItem = styled(MuiListItem)`
  display: inline-block;
  width: auto;
  padding-left: ${(props) => props.theme.spacing(2)}px;
  padding-right: ${(props) => props.theme.spacing(2)}px;
  &,
  &:hover,
  &:active {
    color: #ff0000;
  }
`;

const ListItemText = styled(MuiListItemText)`
  span {
    color: ${(props) => props.theme.footer.color};
  }
`;

function Footer() {
  const { t, i18n } = useTranslation();
  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Hidden smDown>
          <Grid container item xs={12} md={6}>
            <List>
              <ListItem button={true} component="a" href="#">
                <ListItemText primary={t("footer.support")} />
              </ListItem>
              <ListItem button={true} component="a" href="#">
                <ListItemText primary={t("footer.helpCenter")} />
              </ListItem>
              <ListItem button={true} component="a" href="#">
                <ListItemText primary={t("footer.privacy")} />
              </ListItem>
              <ListItem button={true} component="a" href="#">
                <ListItemText primary={t("footer.terms")} />
              </ListItem>
            </List>
          </Grid>
        </Hidden>
        <Grid
          container
          item
          xs={12}
          md={6}
          justifyContent="flex-end"
          alignItems="center"
        >
          <TranslateIcon aria-label={t("footer.language")} />
          <Button
            color={i18n.resolvedLanguage === "en" ? "primary" : "default"}
            onClick={() => changeAndPersistLanguage("en")}
          >
            EN
          </Button>
          <Button
            color={i18n.resolvedLanguage === "es" ? "primary" : "default"}
            onClick={() => changeAndPersistLanguage("es")}
          >
            ES
          </Button>
          <List>
            <ListItem button={true}>
              <ListItemText
                primary={`© ${new Date().getFullYear()} - WifiAds Media Networks`}
              />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default Footer;
